module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kanto-3-e4bc916aabfd5635818a3c7a31296252.png";